// src/pages/TermsConditions.js
// (Assuming this file contains your TermsConditions component)

import React from 'react';
import { Helmet } from 'react-helmet-async'; // 👈 Import the Helmet component

// Common Components
import Navbar from '../../CommonComponent/Navbar/Navbar'; // Importing the Navbar component
import Footer from '../../CommonComponent/Footer/footer';
import NotificationBar from '../../CommonComponent/Notification/NotificationBar';


//page component
import TCcontent from './PageComponent/T&C';

function TermsConditions() {

    // The useMeta hook call is removed and its content is moved into <Helmet>
    return (
        <>
            <Helmet>
                {/* Primary SEO Tags */}
                <title>Terms & Conditions | Marvel Blinds</title>
                <meta
                    name="description"
                    content="Discover what our terms and conditions mean for you. They’re clear and simple. Know your rights and obligations before you shop with us!"
                />
                <link rel="canonical" href={`${process.env.REACT_APP_WEBSITE_URL}/terms-conditions/`} />

                {/* Open Graph Tags (for Social Media) */}
                <meta property="og:locale" content="en_US" />
                <meta property="og:type" content="article" />
                <meta property="og:title" content="Terms & Conditions" />
                <meta
                    property="og:description"
                    content="Discover what our terms and conditions mean for you. They’re clear and simple. Know your rights and obligations before you shop with us!"
                />
                <meta property="og:url" content={`${process.env.REACT_APP_WEBSITE_URL}/terms-conditions/`} />
                <meta property="og:site_name" content="Marvel Blinds" />
            </Helmet>

            {/* Rest of your component structure */}
            <div>
                <Navbar />
                <NotificationBar />
                <TCcontent />
                <Footer />
            </div>
        </>
    );
}

export default TermsConditions;